import { type FC } from "react";

import { faSparkles } from "@fortawesome/pro-duotone-svg-icons/faSparkles";
import { faXmark } from "@fortawesome/pro-duotone-svg-icons/faXmark";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useIsDesktop } from "@application/hooks/use_is_desktop";

import { Button } from "@styled/button";
import { TogglePill } from "@styled/toggle_pill";

// The only assistant trigger and its only close: a violet pill, with an ×
// while the assistant is open. On a phone it is a round violet icon in the
// case's title row, the × in place of the sparkle while open.
export const AssistantToggle: FC<{ open: boolean; onToggle(): void }> = ({
  open,
  onToggle,
}) => {
  const isDesktop = useIsDesktop();

  if (!isDesktop) {
    return (
      <Button
        type="button"
        color="violet"
        size="icon"
        aria-pressed={open}
        aria-label="Assistant"
        onClick={onToggle}
      >
        <FontAwesomeIcon icon={open ? faXmark : faSparkles} />
      </Button>
    );
  }

  return (
    <TogglePill
      tone="violet"
      pressed={open}
      title={open ? "Close the assistant" : undefined}
      onClick={onToggle}
    >
      <FontAwesomeIcon icon={faSparkles} /> Assistant
      {open && <FontAwesomeIcon icon={faXmark} />}
    </TogglePill>
  );
};
